import api from './api';

const canonicaltemplateService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.canonical_group_id) {
      params.append('canonical_group_id', filters.canonical_group_id);
    }
    if (filters.vault_source_group_id) {
      params.append('vault_source_group_id', filters.vault_source_group_id);
    }
    const qs = params.toString();
    return api.get(qs ? `/admin/canonicaltemplates?${qs}` : '/admin/canonicaltemplates');
  },

  getById: async (id) => {
    return api.get(`/admin/canonicaltemplates/${id}`);
  },

  create: async (data) => {
    return api.post('/admin/canonicaltemplates', data);
  },

  update: async (id, data) => {
    return api.put(`/admin/canonicaltemplates/${id}`, data);
  },

  delete: async (id) => {
    return api.delete(`/admin/canonicaltemplates/${id}`);
  }
};

export default canonicaltemplateService;
